/* Duvar theme — vanilla JS */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} TL';
    function fmt(n, prec, th, dec) {
      th = th === undefined ? ',' : th; dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  T.formatMoney = formatMoney;

  /* ---------- Drawers ---------- */
  var overlay = $('[data-overlay]');
  var openEl = null;
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    if (openEl && openEl !== el) closeDrawer(true);
    lastFocus = document.activeElement;
    openEl = el;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    document.body.classList.add('no-scroll');
    var f = el.querySelector('input[type=search], [data-close]');
    if (f) setTimeout(function () { f.focus(); }, 250);
  }
  function closeDrawer(keepOverlay) {
    if (!openEl) return;
    openEl.classList.remove('is-open');
    openEl.setAttribute('aria-hidden', 'true');
    openEl = null;
    if (!keepOverlay && overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { if (!openEl) overlay.hidden = true; }, 300);
    }
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  T.openDrawer = openDrawer; T.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-overlay]')) return closeDrawer();
    if (t.closest('[data-close]')) { e.preventDefault(); return closeDrawer(); }
    if (t.closest('[data-open-menu]')) { e.preventDefault(); return openDrawer($('[data-menu-drawer]')); }
    if (t.closest('[data-open-search]')) { e.preventDefault(); return openDrawer($('[data-search-drawer]')); }
    if (t.closest('[data-open-filters]')) { e.preventDefault(); return openDrawer($('[data-filter-drawer]')); }
    var cartBtn = t.closest('[data-open-cart]');
    if (cartBtn && T.cartType === 'drawer' && $('[data-cart-drawer]')) { e.preventDefault(); return openDrawer($('[data-cart-drawer]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAllDropdowns(); closeDrawer(); }
  });

  /* ---------- Header ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menu drawer panels ---------- */
  // Move the drawer out of the sticky header so it can sit above the overlay.
  function hoistMenu() {
    var fresh = $('.section-header [data-menu-drawer]');
    if (!fresh) return $('[data-menu-drawer]');
    $$('body > [data-menu-drawer]').forEach(function (old) { old.remove(); });
    document.body.appendChild(fresh);
    return fresh;
  }
  var menu = hoistMenu();
  document.addEventListener('shopify:section:load', function () { menu = hoistMenu(); });
  if (menu) {
    menu.addEventListener('click', function (e) {
      var o = e.target.closest('[data-open-panel]');
      if (o) {
        $$('.menu-drawer__panel', menu).forEach(function (p) { p.classList.remove('is-active'); });
        var p = $('[data-panel="' + o.getAttribute('data-open-panel') + '"]', menu);
        if (p) p.classList.add('is-active');
      }
      if (e.target.closest('[data-back]')) {
        $$('.menu-drawer__panel', menu).forEach(function (p) { p.classList.remove('is-active'); });
        $('[data-panel="root"]', menu).classList.add('is-active');
      }
    });
  }

  /* ---------- Generic dropdowns ---------- */
  function closeAllDropdowns(except) {
    $$('[data-dropdown].is-open').forEach(function (d) {
      if (d === except) return;
      d.classList.remove('is-open');
      var l = $('[data-dropdown-list]', d); if (l) l.hidden = true;
      var b = $('[data-dropdown-btn]', d); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dropdown-btn]');
    if (btn) {
      var d = btn.closest('[data-dropdown]');
      var open = !d.classList.contains('is-open');
      closeAllDropdowns(d);
      d.classList.toggle('is-open', open);
      $('[data-dropdown-list]', d).hidden = !open;
      btn.setAttribute('aria-expanded', open);
      return;
    }
    if (!e.target.closest('[data-dropdown]')) closeAllDropdowns();
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var raw = (el.getAttribute('data-end') || '').trim();
    var end = null;
    if (raw) {
      var d = new Date(raw.replace(' ', 'T'));
      if (!isNaN(d)) end = d;
    }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var now = new Date();
      var target = end;
      if (!target) { target = new Date(now); target.setHours(24, 0, 0, 0); }
      var diff = Math.max(0, Math.floor((target - now) / 1000));
      if (end && diff <= 0) { el.hidden = true; return; }
      var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
      $('[data-h]', el).textContent = pad(h);
      $('[data-m]', el).textContent = pad(m);
      $('[data-s]', el).textContent = pad(s);
      el.hidden = false;
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Sliders ---------- */
  $$('[data-slider]').forEach(function (track) {
    var sec = track.closest('section');
    var prev = sec && $('[data-slide="prev"]', sec), next = sec && $('[data-slide="next"]', sec);
    if (!prev || !next) return;
    function step() { var it = track.firstElementChild; return it ? it.getBoundingClientRect().width + 12 : 300; }
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Wishlist ---------- */
  var WKEY = 'duvar:wishlist';
  function wishList() { return store.get(WKEY, []); }
  function syncWish() {
    var list = wishList();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), list = wishList(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    store.set(WKEY, list);
    syncWish();
    var page = b.closest('[data-wishlist-page]');
    if (page && i > -1) { var item = b.closest('.grid-products__item'); if (item) item.remove(); if (!wishList().length) $('[data-wishlist-empty]').hidden = false; }
  });
  syncWish();

  var wpage = $('[data-wishlist-page]');
  if (wpage) {
    var grid = $('[data-wishlist-grid]', wpage), list = wishList();
    if (!list.length) $('[data-wishlist-empty]', wpage).hidden = false;
    Promise.all(list.map(function (h) {
      return fetch(T.routes.root.replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '?section_id=wishlist-card')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var out = '';
      htmls.forEach(function (h) {
        if (!h) return;
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var item = doc.querySelector('.grid-products__item');
        if (item) out += item.outerHTML;
      });
      grid.innerHTML = out;
      if (!out) $('[data-wishlist-empty]', wpage).hidden = false;
      syncWish();
    });
  }

  /* ---------- Grid switch ---------- */
  var cgrid = $('[data-grid]');
  if (cgrid) {
    var GK = 'duvar:cols';
    var setCols = function (n) {
      cgrid.style.setProperty('--cols', n);
      cgrid.setAttribute('data-cols', n);
      $$('.grid-switch [data-cols]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cols') == n); });
    };
    setCols(store.get(GK, 4));
    $$('.grid-switch [data-cols]').forEach(function (b) {
      b.addEventListener('click', function () { var n = +b.getAttribute('data-cols'); store.set(GK, n); setCols(n); });
    });
  }

  /* ---------- Sort & filters ---------- */
  var sortSel = $('[data-sort-select]');
  var ff = $('[data-filter-form]');
  function submitFilters(sortValue) {
    var params = new URLSearchParams();
    if (ff) {
      new FormData(ff).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    } else {
      new URLSearchParams(location.search).forEach(function (v, k) { if (k !== 'page') params.append(k, v); });
    }
    if (sortValue) params.set('sort_by', sortValue);
    params.delete('page');
    location.href = location.pathname + '?' + params.toString();
  }
  if (sortSel) sortSel.addEventListener('change', function () { submitFilters(sortSel.value); });
  if (ff) ff.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(sortSel ? sortSel.value : null); });

  /* ---------- Cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
  }
  function renderDrawer(html) {
    var drawer = $('[data-cart-drawer]');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('[data-cart-inner]');
    if (inner) $('[data-cart-inner]', drawer).innerHTML = inner.innerHTML;
    var cv = drawer.querySelector('[data-cart-count-value]');
    if (cv) setCount(+cv.getAttribute('data-cart-count-value'));
  }
  T.refreshCart = function (open) {
    if (T.cartType !== 'drawer' || !$('[data-cart-drawer]')) { location.href = T.routes.cart; return Promise.resolve(); }
    return fetch(T.routes.root.replace(/\/$/, '') + '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) { renderDrawer(html); if (open) openDrawer($('[data-cart-drawer]')); });
  };

  function changeLine(line, qty, row) {
    if (row) row.classList.add('is-loading');
    var body = { line: line, quantity: qty };
    var drawer = $('[data-cart-drawer]');
    if (drawer) body.sections = 'cart-drawer';
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.status && cart.description) { alert(cart.description); if (row) row.classList.remove('is-loading'); return; }
      if ($('[data-cart-page]')) { location.reload(); return; }
      setCount(cart.item_count);
      if (cart.sections && cart.sections['cart-drawer']) renderDrawer(cart.sections['cart-drawer']);
      else T.refreshCart(false);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    var row = b.closest('[data-line]');
    changeLine(+row.getAttribute('data-line'), Math.max(0, +b.getAttribute('data-qty-change')), row);
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-qty-input]');
    if (!inp) return;
    var row = inp.closest('[data-line]');
    changeLine(+row.getAttribute('data-line'), Math.max(0, parseInt(inp.value, 10) || 0), row);
  });

  /* ---------- Predictive search ---------- */
  var psInput = $('[data-predictive-input]'), psOut = $('[data-predictive-results]');
  if (psInput && psOut) {
    var timer;
    psInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = psInput.value.trim();
      if (q.length < 2) { psOut.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(T.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { psOut.innerHTML = '<p class="count">' + T.strings.noResults + '</p>'; return; }
            var html = '<div class="ps-list">' + items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
              return '<a class="ps-item" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                '<b>' + p.title + '</b><span>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
            }).join('') + '</div><a class="link-arrow ps-more" href="' + T.routes.search + '?q=' + encodeURIComponent(q) + '&options[prefix]=last">' + T.strings.viewAll + ' →</a>';
            psOut.innerHTML = html;
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var n = doc.querySelector('[data-recommendations]');
      if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; syncWish(); }
      else { var s = el.closest('.shopify-section'); if (s) s.hidden = true; }
    }).catch(function () {});
  });

  /* ---------- Product page ---------- */
  function dims(text) {
    var m = String(text).match(/(\d+(?:[.,]\d+)?)\s*[x×X*]\s*(\d+(?:[.,]\d+)?)/);
    return m ? [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))] : null;
  }
  function sameSize(a, b) {
    var da = dims(a), db = dims(b);
    if (!da || !db) return false;
    return (da[0] === db[0] && da[1] === db[1]) || (da[0] === db[1] && da[1] === db[0]);
  }

  $$('[data-pdp]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', root) || $('form.pform', root);
    var input = $('[data-variant-input]', root);
    var addBtn = $('[data-add-btn]', root);
    var addText = $('[data-add-text]', root);
    var errEl = $('[data-form-error]', root);
    var picker = $('[data-size-picker]', root);
    var current = null;
    if (input && input.value) current = product.variants.filter(function (v) { return v.id == input.value; })[0] || null;
    if (!picker && !current) current = product.variants[0];

    /* units */
    var unit = 'cm';
    $$('[data-dim]', root).forEach(function (el) { el.setAttribute('data-orig', el.textContent.trim()); });
    function convert(text) {
      if (unit === 'cm') return text;
      return text.replace(/(\d+(?:[.,]\d+)?)\s*[x×X*]\s*(\d+(?:[.,]\d+)?)\s*(cm)?/i, function (_, a, b) {
        var f = function (n) { return (Math.round(parseFloat(n.replace(',', '.')) / 2.54 * 10) / 10).toString().replace('.', ','); };
        return f(a) + ' x ' + f(b) + ' inch';
      });
    }
    function paintUnits() { $$('[data-dim]', root).forEach(function (el) { el.textContent = convert(el.getAttribute('data-orig')); }); }
    $$('[data-unit]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        unit = b.getAttribute('data-unit');
        $$('[data-unit]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        paintUnits();
      });
    });

    /* gallery */
    var track = $('[data-gallery-track]', root);
    var dots = $$('[data-gallery-dots] span', root);
    function slideTo(i) {
      if (!track) return;
      var n = track.children.length;
      i = (i + n) % n;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    function curIndex() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    var gp = $('[data-gallery-prev]', root), gn = $('[data-gallery-next]', root);
    if (gp) gp.addEventListener('click', function () { slideTo(curIndex() - 1); });
    if (gn) gn.addEventListener('click', function () { slideTo(curIndex() + 1); });
    if (track && dots.length) track.addEventListener('scroll', function () {
      var i = curIndex(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }, { passive: true });
    function showVariantMedia(v) {
      if (!v || !v.featured_media || !track) return;
      var slides = $$('[data-media-id]', track);
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') == v.featured_media.id) { slideTo(i); break; }
    }

    /* add-ons */
    var addons = $$('[data-addon]', root).map(function (el) {
      var data = []; try { data = JSON.parse($('[data-addon-json]', el).textContent); } catch (e) {}
      return { el: el, data: data, selected: null, def: el.getAttribute('data-default-label'), minText: ($('[data-min-price]', el) || {}).textContent };
    });
    function addonVariant(a) {
      if (!a.selected) return null;
      var p = a.data.filter(function (x) { return x.id == a.selected; })[0];
      if (!p) return null;
      var match = null;
      if (current) match = p.variants.filter(function (v) { return v.available && (v.title === current.title || sameSize(v.title, current.title)); })[0];
      return match || p.variants.filter(function (v) { return v.available; })[0] || null;
    }
    function paintAddons() {
      addons.forEach(function (a) {
        $$('[data-addon-opt]', a.el).forEach(function (o) {
          var id = o.getAttribute('data-addon-opt');
          o.classList.toggle('is-selected', (id || null) == a.selected);
          var pe = $('[data-opt-price]', o);
          if (pe && current) {
            var p = a.data.filter(function (x) { return x.id == id; })[0];
            if (p) {
              var mv = p.variants.filter(function (v) { return v.title === current.title || sameSize(v.title, current.title); })[0];
              if (mv) pe.textContent = formatMoney(mv.price);
            }
          }
        });
        var lbl = $('[data-addon-label]', a.el), pr = $('[data-addon-price]', a.el);
        var v = addonVariant(a);
        a.el.classList.toggle('has-value', !!a.selected);
        if (a.selected) {
          var p = a.data.filter(function (x) { return x.id == a.selected; })[0];
          lbl.textContent = p ? p.title : a.def;
          pr.textContent = v ? '+ ' + formatMoney(v.price) : '';
        } else {
          lbl.textContent = a.def;
          if (a.minText) pr.textContent = a.minText;
        }
      });
    }
    addons.forEach(function (a) {
      a.el.addEventListener('click', function (e) {
        var o = e.target.closest('[data-addon-opt]');
        if (!o || o.disabled) return;
        a.selected = o.getAttribute('data-addon-opt') || null;
        closeAllDropdowns();
        paintAddons();
        updatePrice();
      });
    });

    /* price + button */
    var priceEl = $('[data-pdp-price]', root);
    var instEl = $('[data-inst-amount]', root);
    function updatePrice() {
      var v = current || null;
      if (priceEl && v) {
        var html = '<span class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '">' +
          (v.compare_at_price > v.price ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '') +
          '<span class="price__current">' + formatMoney(v.price) + '</span></span>';
        priceEl.innerHTML = html;
      }
      if (instEl && v) {
        var total = v.price;
        addons.forEach(function (a) { var av = addonVariant(a); if (av) total += av.price; });
        instEl.textContent = formatMoney(Math.floor(total / (T.installments || 6)));
      }
    }
    function updateButton() {
      if (!addBtn) return;
      if (!current) { addBtn.disabled = true; addText.textContent = T.strings.addToCart; return; }
      addBtn.disabled = !current.available;
      addText.textContent = current.available ? T.strings.addToCart : T.strings.soldOut;
    }

    if (picker) {
      picker.addEventListener('click', function (e) {
        var o = e.target.closest('[data-variant-id]');
        if (!o || o.disabled) return;
        var id = o.getAttribute('data-variant-id');
        current = product.variants.filter(function (v) { return v.id == id; })[0];
        input.value = id;
        $$('[data-variant-id]', picker).forEach(function (x) { x.classList.toggle('is-selected', x === o); });
        var lbl = $('[data-size-label]', picker);
        lbl.setAttribute('data-orig', current.title);
        lbl.textContent = convert(current.title);
        $('[data-dropdown]', picker).classList.add('is-selected');
        closeAllDropdowns();
        if (errEl) errEl.hidden = true;
        updatePrice(); updateButton(); paintAddons(); showVariantMedia(current);
        if (history.replaceState) {
          var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u.toString());
        }
      });
      if (current) $('[data-dropdown]', picker).classList.add('is-selected');
    }

    /* submit */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current) {
        if (errEl) { errEl.textContent = 'Please select a size.'; errEl.hidden = false; }
        var b = picker && $('[data-dropdown-btn]', picker); if (b) b.click();
        return;
      }
      var items = [{ id: current.id, quantity: 1 }];
      addons.forEach(function (a) {
        var av = addonVariant(a);
        if (av) items.push({ id: av.id, quantity: 1, properties: { '_eser': product.title + ' / ' + current.title } });
      });
      addBtn.disabled = true; addText.textContent = T.strings.adding;
      var body = { items: items };
      if (T.cartType === 'drawer' && $('[data-cart-drawer]')) body.sections = 'cart-drawer';
      fetch(T.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        updateButton();
        if (res.status && res.description) { if (errEl) { errEl.textContent = res.description; errEl.hidden = false; } return; }
        if (T.cartType !== 'drawer' || !$('[data-cart-drawer]')) { location.href = T.routes.cart; return; }
        if (res.sections && res.sections['cart-drawer']) { renderDrawer(res.sections['cart-drawer']); openDrawer($('[data-cart-drawer]')); }
        else T.refreshCart(true);
      }).catch(function () { updateButton(); });
    });

    updatePrice(); updateButton(); paintAddons();
  });
})();
